// Recovered compiled webpack factory 62296. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      DecodeError: function () {
        return h;
      },
      MiddlewareNotFoundError: function () {
        return y;
      },
      MissingStaticPage: function () {
        return g;
      },
      NormalizeError: function () {
        return _;
      },
      PageNotFoundError: function () {
        return m;
      },
      SP: function () {
        return d;
      },
      ST: function () {
        return p;
      },
      WEB_VITALS: function () {
        return r;
      },
      execOnce: function () {
        return n;
      },
      getDisplayName: function () {
        return l;
      },
      getLocationOrigin: function () {
        return i;
      },
      getURL: function () {
        return s;
      },
      isAbsoluteUrl: function () {
        return o;
      },
      isResSent: function () {
        return u;
      },
      loadGetInitialProps: function () {
        return f;
      },
      normalizeRepeatedSlashes: function () {
        return c;
      },
      stringifyError: function () {
        return v;
      },
    }));
  let r = ["CLS", "FCP", "FID", "INP", "LCP", "TTFB"];
  function n(e) {
    let t,
      r = !1;
    return function () {
      for (var n = arguments.length, a = Array(n), o = 0; o < n; o++) a[o] = arguments[o];
      return (r || ((r = !0), (t = e(...a))), t);
    };
  }
  let a = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/,
    o = (e) => a.test(e);
  function i() {
    let { protocol: e, hostname: t, port: r } = window.location;
    return e + "//" + t + (r ? ":" + r : "");
  }
  function s() {
    let { href: e } = window.location,
      t = i();
    return e.substring(t.length);
  }
  function l(e) {
    return "string" == typeof e ? e : e.displayName || e.name || "Unknown";
  }
  function u(e) {
    return e.finished || e.headersSent;
  }
  function c(e) {
    let t = e.split("?");
    return (
      t[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (t[1] ? "?" + t.slice(1).join("?") : "")
    );
  }
  async function f(e, t) {
    let r = t.res || (t.ctx && t.ctx.res);
    if (!e.getInitialProps)
      return t.ctx && t.Component ? { pageProps: await f(t.Component, t.ctx) } : {};
    let n = await e.getInitialProps(t);
    if (r && u(r)) return n;
    if (!n)
      throw Object.defineProperty(
        Error(
          '"' +
            l(e) +
            '.getInitialProps()" should resolve to an object. But found "' +
            n +
            '" instead.',
        ),
        "__NEXT_ERROR_CODE",
        { value: "E394", enumerable: !1, configurable: !0 },
      );
    return n;
  }
  let d = "undefined" != typeof performance,
    p =
      d &&
      ["mark", "measure", "getEntriesByName"].every((e) => "function" == typeof performance[e]);
  class h extends Error {}
  class _ extends Error {}
  class m extends Error {
    constructor(e) {
      (super(),
        (this.code = "ENOENT"),
        (this.name = "PageNotFoundError"),
        (this.message = "Cannot find module for page: " + e));
    }
  }
  class g extends Error {
    constructor(e, t) {
      (super(), (this.message = "Failed to load static file for page: " + e + " " + t));
    }
  }
  class y extends Error {
    constructor() {
      (super(), (this.code = "ENOENT"), (this.message = "Cannot find the middleware module"));
    }
  }
  function v(e) {
    return JSON.stringify({ message: e.message, stack: e.stack });
  }
}
